import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";

const HostHubUpcomingPanelEmptyState = () => (
  <div className="tw-flex tw-flex-col tw-gap-[8px]">
    <Text className="tw-my-0" typeface="body-2-m">
      <FormattedMessage
        defaultMessage="No bookings scheduled this month"
        id="host_hub.upcoming_panel.empty.title"
      />
    </Text>
    <Text className="tw-my-0 tw-text-gray-600" typeface="body-1-long">
      <FormattedMessage
        defaultMessage="Keep your availability updated on your calendar and respond quickly to requests and inquiries to attract more guests."
        id="host_hub.upcoming_panel.empty.description"
      />
    </Text>
  </div>
);

export default HostHubUpcomingPanelEmptyState;
